// extracted by mini-css-extract-plugin
export default {"invoices":"Invoices_invoices__7+NTe","chartRow":"Invoices_chartRow__+Nd+H","chart":"Invoices_chart__s7naT"};